export const CreditCard = () => {
  return <div data-testid="creditCardContainer" data-quickstream-api="creditCardContainer" data-hj-suppress></div>;
};

export default CreditCard;
